import imageCompression from 'browser-image-compression'

const COMPRESS_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  fileType: 'image/webp' as const,
  useWebWorker: true,
}

/**
 * Compresses an image File to WebP format (≤1 MB, ≤1920 px).
 * Falls back to the original file if compression fails.
 */
export async function compressToWebP(file: File): Promise<File> {
  try {
    const compressed = await imageCompression(file, COMPRESS_OPTIONS)
    const baseName = file.name.replace(/\.[^.]+$/, '')
    return new File([compressed], `${baseName}.webp`, { type: 'image/webp' })
  } catch {
    // Graceful fallback — never block the upload
    return file
  }
}
